import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, fmtDateTime } from "../lib/api";
import { BadgeCheck, ShieldX, ShieldAlert, Loader2, FileSignature } from "lucide-react";

const Row = ({ l, v, testid }) => <div className="flex justify-between gap-4 border-b border-slate-100 py-2 text-sm"><span className="text-slate-500">{l}</span><span className="text-right font-medium text-navy" data-testid={testid}>{v || "—"}</span></div>;

export default function VerifyCourrier() {
  const { token } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/gic/verifier/${token}`).then(({ data }) => setData(data)).catch(() => setData({ valid: false }));
  }, [token]);

  if (!data) return <div className="flex min-h-[60vh] items-center justify-center"><Loader2 className="animate-spin text-[#0E7C7B]" size={28} /></div>;
  const ok = data.valid && data.integre;

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-xl items-center px-4 py-16" data-testid="verify-courrier-page">
      <div className="w-full rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
        <p className="flex items-center justify-center gap-2 text-center font-mono text-xs uppercase tracking-widest text-[#0E7C7B]"><FileSignature size={15} /> Vérification de courrier signé — GIC-IA</p>
        <div className="mt-6 text-center">
          <div className={`mx-auto flex h-16 w-16 items-center justify-center rounded-full ${ok ? "bg-emerald-100" : data.valid ? "bg-amber-100" : "bg-rose-100"}`}>
            {ok ? <BadgeCheck size={34} className="text-emerald-600" /> : data.valid ? <ShieldAlert size={34} className="text-amber-600" /> : <ShieldX size={34} className="text-rose-600" />}
          </div>
          <h1 className="mt-4 text-2xl font-bold text-navy" data-testid="verify-courrier-status">{ok ? "Courrier authentique" : data.valid ? "Signature trouvée — contenu modifié" : "Jeton inconnu"}</h1>
          <p className="mt-1 text-sm text-slate-500">{ok ? "L'empreinte du document correspond à celle enregistrée lors de la signature." : data.valid ? "L'empreinte actuelle ne correspond plus à celle enregistrée à la signature." : "Aucun courrier signé ne correspond à ce jeton de vérification."}</p>
        </div>
        {data.valid && (
          <div className="mt-6" data-testid="verify-courrier-details">
            <Row l="Référence" v={data.reference} testid="verify-courrier-ref" />
            <Row l="Objet" v={data.objet} testid="verify-courrier-objet" />
            <Row l="Établissement" v={data.etablissement} />
            <Row l="Direction émettrice" v={data.direction} testid="verify-courrier-direction" />
            <Row l="Signataire" v={data.signataire ? `${data.signataire}${data.signataire_titre ? ` — ${data.signataire_titre}` : ""}` : data.signataire_titre} testid="verify-courrier-signataire" />
            <Row l="Signé le" v={fmtDateTime(data.signed_at)} testid="verify-courrier-date" />
            <Row l="Destinataires" v={(data.destinataires || []).filter(Boolean).join(", ")} />
            <Row l="Mode de signature" v={data.mode === "image" ? "Image de signature" : "Typographique"} />
            <div className="mt-3 rounded-xl bg-slate-50 p-3"><p className="text-[11px] uppercase tracking-wide text-slate-500">Empreinte SHA-256</p><p className="mt-1 break-all font-mono text-xs text-navy" data-testid="verify-courrier-hash">{data.hash}</p></div>
          </div>
        )}
        <p className="mt-6 text-center text-[11px] text-slate-400">Signature électronique simple (phase 1) — horodatage et empreinte d'intégrité, sans valeur juridique probante ni infrastructure PKI.</p>
      </div>
    </div>
  );
}
